// src/context/ConfigStylesProvider.js
import React from 'react';
import { useConfig } from './ConfigContext';
import { ConfigStyles } from '../styles/configStyles';

export const ConfigStylesProvider = ({ children }) => {
  const { config } = useConfig();
  
  return (
    <>
      <ConfigStyles 
        primary={config.colors.primary} 
        secondary={config.colors.secondary}
        textPrimary={config.colors.textPrimary}
        textSecondary={config.colors.textSecondary}
      />
      {children}
    </>
  );
};